import updateOptionsWithValue from "./utils/updateOptionsWithValue";
import { useCallback, useMemo, useState } from "react";
import getSelectedProductInformation from "./utils/getSelectedProductInformation";

const useSelectedProductInformation = (
  product,
  options,
  initialSelectedOptions = {}
) => {
  const [selectedOptions, setSelectedOptions] = useState(
    initialSelectedOptions
  );
  const setOption = useCallback((optionId, optionValue) => {
    setSelectedOptions(updateOptionsWithValue(optionId, optionValue));
  }, []);

  const { selectedSku, selectedProduct, baseProduct } = useMemo(
    () => getSelectedProductInformation(product, options, selectedOptions),
    [product, options, selectedOptions]
  );

  if (!selectedProduct?.options) {
    return {
      selectedOptions,
      setSelectedOptions,
      setOption,
      selectedSku,
      selectedProduct,
      baseProduct,
    };
  }

  const newProductOptions = selectedProduct.options.map(
    (option) => ({
      id: option.attribute.id,
      label: option.attribute.label,
      values: option.values,
    }),
    []
  );

  return {
    selectedOptions,
    setSelectedOptions,
    setOption,
    selectedSku,
    baseProduct,
    selectedProduct: {
      ...selectedProduct,
      stock: {
        ...selectedProduct.stock,
        isInStock:
          baseProduct.stock?.isInStock &&
          (selectedProduct.currentConfigIsInStock ||
            selectedProduct.stock?.isInStock),
      },
      options: newProductOptions,
    },
  };
};

export default useSelectedProductInformation;
